import { Injectable } from '@angular/core';
import { OperatorFunction } from 'rxjs';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { finalize, tap, mergeMapTo } from 'rxjs/operators';

@Injectable()
export class LoadingService {
  public static clear = 'X-Clear';
  public static clearAll = 'X-Clear-All';

  private messageSubject = new ReplaySubject<string>(1);
  private clearSubject = new ReplaySubject<string>(1);
  private messages: string[] = [];

  public constructor() { }

  public clearMessage(message?: string): void {
    if (message == null || message == undefined) {
      this.messages.shift();
      this.clearSubject.next(LoadingService.clear);
    } else {
      this.messages.splice(this.messages.indexOf(message), 1);
      this.clearSubject.next(message);
    }
  }

  public clearAllMessages(): void {
    this.messages.length = 0;
    this.clearSubject.next(LoadingService.clearAll);
  }

  public setMessage(message: string): void {
    this.messages.push(message);
    this.messageSubject.next(message);
  }

  public onMessageUpdate(): Observable<string> {
    return this.messageSubject;
  }

  public onMessageClear(): Observable<string> {
    return this.clearSubject;
  }

  public isLoading(message?: string | string[]): boolean {
    if (message == null || message == undefined) {
      return this.messages.length !== 0;
    } else if (message instanceof Array) {
      return this.messages.filter(v => message.indexOf(v) !== -1).length > 0;
    } else {
      return this.messages.includes(message);
    }
  }

  public wrapRequestWithLoadingMsg = <T>(o: Observable<T>, msg?: string) => this.wrapRequest<T>(msg)(o);

  public wrapRequest<T>(msg: string = 'Loading...'): OperatorFunction<T, T> {
    return obs => of({}).pipe(
      tap(() => this.setMessage(msg)),
      mergeMapTo(obs),
      finalize(() => this.clearMessage(msg))
    );
  }
}
